// removed by extract-text-webpack-plugin
module.exports = {"layoutWrapperMain":"EmailVerificationPage__layoutWrapperMain__3551d","root":"EmailVerificationPage__root__1FG2a","content":"EmailVerificationPage__content__S8qcM","error":"EmailVerificationPage__error__mqfLJ"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/EmailVerificationPage/EmailVerificationPage.css
// module id = 2299
// module chunks = 0